import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import "./chart.css";
import "./index.css";
import "./step.css";
import Footer from "./layouts/Footer";
import Nav from "./layouts/nav";
import Home from "./components/Dashboard/Home";
import { ThemeContext } from "../context/ThemeContext";
import Coverage from "./components/table/FilteringTable/Coverage";
import Setting from "./layouts/Setting";
import Vendor from "./components/table/FilteringTable/Vendor";
import Links from "./components/table/FilteringTable/Links";

const Markup = () => {
  const { menuToggle } = useContext(ThemeContext);
  const routes = [
    /// Dashboard
    { url: "", component: Home },
    { url: "dashboard", component: Home },
    { url: "coverage", component: Coverage },
    { url: "vendor", component: Vendor },
    { url: "links", component: Links },
  ];
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let pagePath = path.split("-").includes("page");
  return (
    <>
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "vh-100"}  ${
          menuToggle ? "menu-toggle" : ""
        }`}
      >
        {!pagePath && <Nav />}

        <div className={`${!pagePath ? "content-body" : ""}`}>
          <div className={`${!pagePath ? "container-fluid" : ""}`}>
            <Routes>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  element={<data.component />}
                />
              ))}
            </Routes>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
      <Setting />
    </>
  );
};

export default Markup;
